import { render, staticRenderFns } from "./final.vue?vue&type=template&id=6860a9cb&scoped=true&"
import script from "./final.vue?vue&type=script&lang=js&"
export * from "./final.vue?vue&type=script&lang=js&"
import style0 from "./final.vue?vue&type=style&index=0&id=6860a9cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6860a9cb",
  null
  
)

export default component.exports